<template>
	<!-- <van-swipe-cell @open="open"> -->
	<div v-if="this.$store.getters.ImgShow && environment" class="loaddingShow">
		<img src="./assets/img/loaddingShow.png" />
	</div>

	<div v-else='!this.$store.getters.ImgShow' id="app"
		:style="`min-height: calc(${showTabbar ? '100vh - 50px' : '100vh'})`">
		<vue-page-stack>
			<router-view />
		</vue-page-stack>
		<Tabbar v-if="showTabbar"/>
		<transition name="slide-fade">
			<div class="orientationError" v-if="orientationError && orientationError !== 'loading'">
				为了更好的体验 请将手机旋转至{{orientationError === 'horizontal' ? '横屏' : '竖屏'}}使用
			</div>
		</transition>
	</div>
</template>
<script>
	import {
		PresentType
	} from '../config/index.js'
	import Tabbar from './components/tabbar/tabbar'

	export default {
		name: 'App',
		data() {
			return {
				environment: !PresentType, //生产环境不展示（麻烦）
				showTabbar: false, //  是否显示tabbar
				orientationError: null, //  屏幕方向是否有误
				show: true,
				tabarIndex: 0, //底部按钮默认选中哪个
			}
		},
		components: {
			Tabbar,
		},
		mounted() {
			this.tabarIndex = 1;
			if (this.$store.getters.ImgShow) {
				setTimeout(x => {
					this.$store.commit('SET_IMGSHOW', false)
				}, 2000)
			}

			this.showTabbar = this.$route.path === '/message' || this.$route.path === '/' || this.$route.path === '/me';
			if (!!localStorage.getItem('userInfo')) {
				this.$store.commit('SET_USER_INFO', JSON.parse(localStorage.getItem('userInfo')))
			}
			this.createListenOrientation()
			this.changeOrientationError(this.$route)

			if (!PresentType) { //App模式
				// this.$Toast({
				// 	type: 'loading',
				// 	message: '正在加载,请稍后!',
				// 	duration: 0,
				// 	overlay: true,
				// 	closeOnClick: true,
				// 	forbidClick: true
				// })
				let that = this;
				document.addEventListener('plusready', function() { //监听plus初始化后获取ClientId
					plus.runtime.setBadgeNumber(0); //默认在app打开后清除角标未读数字
					//console.log('当前系统标识', plus.os.name.toLowerCase())

					plus.push.getClientInfoAsync((info) => {
						that.$store.commit('SET_CLIENTINFO', info);
						that.$Toast.clear(); //获取到Cid再关闭加载
					}, err => {});

					//IOS在线状态主动添加消息提醒
					plus.push.addEventListener('receive', msg => {
						/*更改push服务器记录*/
						var GeTuiSdk = plus.ios.importClass('GeTuiSdk');
						GeTuiSdk.setBadge(0);
						if (navigator.userAgent.indexOf('iPhone') !== -1) { //判断当前系统环境
							if (msg.type == 'receive' && msg.aps) {
								let options = {
									cover: false,
									sound: 'system',
									title: msg.aps.alert.title
								};
								plus.push.createMessage(msg.aps.alert.body, JSON.stringify(msg.payload),
									options); //创建消息
							}
						}
					})

					plus.push.addEventListener('click', msg => {
						if (typeof msg.payload == 'object') {
							if (msg.payload.DH) {
								//做一些操作
							}
						} else {
							var data = JSON.parse(msg.payload)
							//做一些操作
						}
					}, false);
				}, false);
			}
		},
		methods: {
			//  屏幕旋转监听
			createListenOrientation() {
				window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", this
					.changeOrientation)
			},
			removeListenOrientation() {
				window.removeEventListener("onorientationchange" in window ? "orientationchange" : "resize", this
					.changeOrientation)
			},
			changeOrientation() {
				if ((this.$route.name === 'QualityTest' || this.$route.name === 'PollingimplementDefault_XS' || this
						.$route.name === 'MaintainImplementDefault') && window.orientation === 90 || this
					.orientationError ===
					'vertical' && window.orientation === 0) {
					this.orientationError = null
				} else {
					this.changeOrientationError(this.$route)
				}
			},
			changeOrientationError(router) {
				if ((this.$route.name === 'QualityTest' || this.$route.name === 'PollingimplementDefault_XS' || this
						.$route.name === 'MaintainImplementDefault') && window.orientation !== 90) {
					if (!PresentType) { //App模式
						console.log('这是屏幕旋转111');
                        //plus.screen.unlockOrientation();
						plus.screen.lockOrientation('landscape-primary') //主动旋转屏幕
					} else { //被动旋转
						this.orientationError = 'horizontal'
						this.closeLog()
					}
				} else if (window.orientation === 90) {
					this.orientationError = 'vertical'
					this.closeLog()
				} else {
					this.orientationError = null
				}
			},
			closeLog() {
				setTimeout(() => {
					this.orientationError = null
				}, 1000)
			}
		},
		beforeDestroy() {
			this.removeListenOrientation()
		},
		watch: {
			$route(to, from) {
				if((from.name === 'QualityTest' || from.name === 'PollingimplementDefault_XS' || from.name === 'MaintainImplementDefault')&& !PresentType){
					plus.screen.lockOrientation('portrait-primary') //主动回转屏幕
				}
				this.showTabbar = to.path === '/message' || to.path === '/' || to.path === '/me'
				this.changeOrientationError(to);
				var that = this;
				if (this.showTabbar && window.plus) {
					this.$Mui.plusReady(function() {
						let exitApp = !1;
						that.$Mui.back = () => {
							if (exitApp) {
								if (window.plus) plus.runtime.quit();
								return;
							}
							that.$Toast({
								message: '再点击一次退出应用!',
								position: 'bottom'
							});
							exitApp = !0;
							setTimeout(() => {
								exitApp = !1;
							}, 2000)
						}
					})
				} else {
					this.$Mui.plusReady(function() {
						that.$Mui.back = () => {
							that.$router.go(-1);
						}
					})
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.orientationError {
		position: fixed;
		width: 100vw;
		height: 100vh;
		background: #fff;
		top: 0;
		left: 0;
		z-index: 30;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #999;
		touch-action: none;
	}

	.slide-fade-enter-active,
	.slide-fade-leave-active {
		transition: all .6s;
	}

	.slide-fade-enter,
	.slide-fade-leave-to {
		opacity: 0;
	}

	.loaddingShow {
		img {
			width: 100%;
			height: 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/App.vue